export default __webpack_public_path__ + "static/vindecoder_ss_1-30379a2695d22c6af1e9b03a4a4ff3f2.jpg";